'use client';

import './styles.scss';

import { PaymentMethodEnum } from 'gql/graphql';
import { useBillingPaymentMethod } from 'providers/BillingInfoProviders/useBillingPaymentMethod';
import BillingInfoForm from './_components/BillingInfoForm';
import CreditCardWrapper from './_components/CreditCardWrapper';

const InfoPage = () => {
  const { data } = useBillingPaymentMethod();

  return (
    <div className="mt-6 flex w-full flex-1 gap-6">
      <BillingInfoForm />
      {data?.paymentMethod === PaymentMethodEnum.CreditCard && <CreditCardWrapper />}
      {data?.paymentMethod !== PaymentMethodEnum.CreditCard && (
        <div className="w-[37.5%]  opacity-0" />
      )}
    </div>
  );
};

export default InfoPage;
